import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CommodityFieldList } from '../_models/irrigation_v2';
import {
  loadIrrigationAdvice,
  loadIrrigationAdviceFailure,
  loadIrrigationAdviceSuccess,
} from '../_actions/irrigationAdvice';

export interface IrrigationAdviceState extends EntityState<CommodityFieldList> {
  calculationEnabled?: boolean;
  loaded: boolean;
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<CommodityFieldList> = createEntityAdapter<CommodityFieldList>({
  selectId: (commodity) => commodity.commodityId, // Replace `customId` with the actual unique identifier property
});

const initialState: IrrigationAdviceState = adapter.getInitialState({
  calculationEnabled: null,
  loaded: false,
  loading: false,
  error: null,
});

const irrigationAdviceReducer = createReducer(
  initialState,

  on(loadIrrigationAdvice, (state) => {
    return {
      ...state,
      calculationEnabled: null,
      loaded: false,
      loading: true,
      error: null,
    };
  }),

  on(loadIrrigationAdviceSuccess, (state, { commodities, calculationEnabled }) =>
    adapter.setAll(commodities || [], {
      ...state,
      calculationEnabled,
      loading: false,
      loaded: true,
    })
  ),

  on(loadIrrigationAdviceFailure, (state, { error }) => {
    return {
      ...state,
      calculationEnabled: null,
      loaded: true,
      loading: false,
      error,
    };
  })
);

export function reducer(state: IrrigationAdviceState | undefined, action: Action) {
  return irrigationAdviceReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
